import { render, staticRenderFns } from "./CreateConsultantForm.vue?vue&type=template&id=1bf90c91&"
import script from "./CreateConsultantForm.vue?vue&type=script&lang=js&"
export * from "./CreateConsultantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports